// Mac 使用的API
export default {
    call(functionName, params) {
        if (!window.WebViewJavascriptBridge) {
            return Promise.reject(new Error('not in mac thunder'));
        }
        return new Promise((resolve, reject) => {
            window.WebViewJavascriptBridge.callHandler(functionName, params, (err, value) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(value);
                }
            });
        });
    },
    on(eventName, callback) {
        try {
            return window.WebViewJavascriptBridge.addEventListener(eventName, callback);
        }
        catch (e) {
            console.error('not in mac thunder');
        }
    },
    off(eventName, listenId) {
        try {
            return window.WebViewJavascriptBridge.removeEventListener(eventName, listenId);
        }
        catch (e) {
            console.error('not in mac thunder');
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFjLWFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvbWFjLWFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxhQUFhO0FBRWIsZUFBZTtJQUNiLElBQUksQ0FBRSxZQUFvQixFQUFFLE1BQVc7UUFDckMsSUFBSSxDQUFDLE1BQU0sQ0FBQyx1QkFBdUIsRUFBRTtZQUNuQyxPQUFPLE9BQU8sQ0FBQyxNQUFNLENBQUMsSUFBSSxLQUFLLENBQUMsb0JBQW9CLENBQUMsQ0FBQyxDQUFBO1NBQ3ZEO1FBQ0QsT0FBTyxJQUFJLE9BQU8sQ0FBQyxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsRUFBRTtZQUNyQyxNQUFNLENBQUMsdUJBQXVCLENBQUMsV0FBVyxDQUFDLFlBQVksRUFBRSxNQUFNLEVBQUUsQ0FBQyxHQUFRLEVBQUUsS0FBVSxFQUFFLEVBQUU7Z0JBQ3hGLElBQUksR0FBRyxFQUFFO29CQUNQLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTtpQkFDWjtxQkFBTTtvQkFDTCxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUE7aUJBQ2Y7WUFDSCxDQUFDLENBQUMsQ0FBQTtRQUNKLENBQUMsQ0FBQyxDQUFBO0lBQ0osQ0FBQztJQUNELEVBQUUsQ0FBRSxTQUFpQixFQUFFLFFBQWtCO1FBQ3ZDLElBQUk7WUFDRixPQUFPLE1BQU0sQ0FBQyx1QkFBdUIsQ0FBQyxnQkFBZ0IsQ0FBQyxTQUFTLEVBQUUsUUFBUSxDQUFDLENBQUE7U0FDNUU7UUFBQyxPQUFPLENBQUMsRUFBRTtZQUNWLE9BQU8sQ0FBQyxLQUFLLENBQUMsb0JBQW9CLENBQUMsQ0FBQTtTQUNwQztJQUNILENBQUM7SUFDRCxHQUFHLENBQUUsU0FBaUIsRUFBRSxRQUFnQjtRQUN0QyxJQUFJO1lBQ0YsT0FBTyxNQUFNLENBQUMsdUJBQXVCLENBQUMsbUJBQW1CLENBQUMsU0FBUyxFQUFFLFFBQVEsQ0FBQyxDQUFBO1NBQy9FO1FBQUMsT0FBTyxDQUFDLEVBQUU7WUFDVixPQUFPLENBQUMsS0FBSyxDQUFDLG9CQUFvQixDQUFDLENBQUE7U0FDcEM7SUFDSCxDQUFDO0NBQ0YsQ0FBQSJ9